import { gql } from '@apollo/client';

export const getLeads = gql`
  query GetLeads(
    $limit: Int
    $offset: Int
    $sort: [lead_order_by!]
    $status: [String!]
  ) {
    leads: lead(
      limit: $limit
      offset: $offset
      order_by: $sort
      where: { status: { _in: $status } }
    ) {
      id
      due
      content
      createdAt: created_at
      metadata
      source
      updatedAt: updated_at
      user
      status
      lost_reason
      lost_reason_notes
      lost_reason_at
      # messages: lead_contacts {
      #   id
      # }
      # conversions: lead_conversions {
      #   id
      # }
    }

    agg: lead_aggregate(where: { status: { _in: $status } }) {
      aggregate {
        count
      }
    }
  }
`;

export const getLeadById = gql`
  query getLeadById($id: uuid!) {
    lead: lead_by_pk(id: $id) {
      id
      due
      content
      createdAt: created_at
      claimed_at
      sales_opportunity_at
      metadata
      source
      data
      updatedAt: updated_at
      user
      who
      status
      lost_reason
      lost_reason_notes
      lost_reason_at
      userByWho {
        id
        given_name
        family_name
      }
      cadence_state {
        id
        started_at
        paused
        paused_at
        version
        touchpoint_logs(order_by: { created_at: asc }) {
          id
          day
          channel
          status
          skip_reason
          skip_notes
          call_outcome
          slot
          created_at
        }
      }
      notes(order_by: { created_at: asc }) {
        id
        data: noteByNote {
          id
          content
          createdAt: created_at
          updatedAt: updated_at
          user
        }
      }
      contacts(order_by: { created_at: desc }) {
        id
        message
        subject
        type
        source
        call_id
        createdAt: created_at
        updatedAt: updated_at
        user {
          id
          name: given_name
          surname: family_name
        }
        call {
          id
          type
          voicemail
          callType: call_type
          payload
          createdAt: created_at
          employee {
            id
            name: given_name
            surname: family_name
          }
          notes {
            id
            data: noteByNote {
              id
              content
              createdAt: created_at
              updatedAt: updated_at
              user
            }
          }
        }
      }
      contacts_aggregate(where: { type: { _neq: "call" } }) {
        aggregate {
          count
        }
      }
      notes_aggregate {
        aggregate {
          count
        }
      }
      conversions {
        id
        value
        createdAt: created_at
        user: user {
          id
          name: given_name
          surname: family_name
        }
        eventByEvent {
          detail {
            title
          }
        }
      }
      track_assignments(order_by: { priority: asc }) {
        id
        priority
        source
        assigned_at
        track {
          id
          name
          slug
          is_active
          track_steps(where: { is_active: { _eq: true } }) {
            id
            name
            trigger_type
            cadence_day
            channel
            subject
            body_html
            attachment_urls
          }
        }
      }
    }
  }
`;

export const updateLeadById = gql`
  mutation updateLeadById($id: uuid!, $data: lead_set_input!) {
    update_lead_by_pk(pk_columns: { id: $id }, _set: $data) {
      id
      who
      claimed_at
      sales_opportunity_at
      status
    }
  }
`;

export const convertLeadToSalesOpportunity = gql`
  mutation ConvertLeadToSalesOpportunity(
    $id: uuid!
    $salesOpportunityAt: timestamptz!
    $status: String!
  ) {
    update_lead_by_pk(
      pk_columns: { id: $id }
      _set: { sales_opportunity_at: $salesOpportunityAt, status: $status }
    ) {
      id
      status
      sales_opportunity_at
      updatedAt: updated_at
    }
  }
`;

export const moveLeadBackToContact = gql`
  mutation MoveLeadBackToContact($id: uuid!) {
    update_lead_by_pk(
      pk_columns: { id: $id }
      _set: { sales_opportunity_at: null }
    ) {
      id
      status
      sales_opportunity_at
      updatedAt: updated_at
    }
  }
`;

export const claimLead = gql`
  mutation claimLead($id: uuid!, $who: uuid!, $claimedAt: timestamptz!) {
    update_lead_by_pk(
      pk_columns: { id: $id }
      _set: { who: $who, claimed_at: $claimedAt }
    ) {
      id
      who
      claimed_at
    }
  }
`;

export const releaseLead = gql`
  mutation releaseLead($id: uuid!) {
    update_lead_by_pk(
      pk_columns: { id: $id }
      _set: { who: null, claimed_at: null }
    ) {
      id
      who
      claimed_at
    }
  }
`;

export const updateLeadStatus = gql`
  mutation UpdateLeadStatus($id: uuid!, $status: String!) {
    update_lead_by_pk(pk_columns: { id: $id }, _set: { status: $status }) {
      id
      content
      createdAt: created_at
      metadata
      source
      updatedAt: updated_at
      user
      status
      lost_reason
      lost_reason_notes
      lost_reason_at
      notes {
        id
        data: noteByNote {
          id
          content
          createdAt: created_at
          updatedAt: updated_at
          user
        }
      }
      contacts(order_by: { created_at: desc }) {
        id
        message
        subject
        type
        source
        call_id
        createdAt: created_at
        updatedAt: updated_at
        user {
          id
          name: given_name
          surname: family_name
        }
        call {
          id
          type
          voicemail
          callType: call_type
          payload
          createdAt: created_at
          employee {
            id
            name: given_name
            surname: family_name
          }
          notes {
            id
            data: noteByNote {
              id
              content
              createdAt: created_at
              updatedAt: updated_at
              user
            }
          }
        }
      }
      contacts_aggregate(where: { type: { _neq: "call" } }) {
        aggregate {
          count
        }
      }
      notes_aggregate {
        aggregate {
          count
        }
      }
      conversions {
        id
        value
        createdAt: created_at
        user: user {
          id
          name: given_name
          surname: family_name
        }
        eventByEvent {
          detail {
            title
          }
        }
      }
    }
  }
`;

export const closeLead = gql`
  mutation CloseLead(
    $id: uuid!
    $lostReason: String!
    $lostReasonNotes: String
    $lostReasonAt: timestamptz!
  ) {
    update_lead_by_pk(
      pk_columns: { id: $id }
      _set: {
        status: "CLOSED"
        lost_reason: $lostReason
        lost_reason_notes: $lostReasonNotes
        lost_reason_at: $lostReasonAt
      }
    ) {
      id
      status
      lost_reason
      lost_reason_notes
      lost_reason_at
      updatedAt: updated_at
    }
  }
`;

export const reopenLead = gql`
  mutation ReopenLead($id: uuid!) {
    update_lead_by_pk(
      pk_columns: { id: $id }
      _set: {
        status: "NEW"
        lost_reason: null
        lost_reason_notes: null
        lost_reason_at: null
      }
    ) {
      id
      status
      lost_reason
      lost_reason_notes
      lost_reason_at
      updatedAt: updated_at
    }
  }
`;

export const updateLeadsUser = gql`
  mutation UpdateLead($id: uuid!, $user: uuid!) {
    update_lead_by_pk(pk_columns: { id: $id }, _set: { user: $user }) {
      id
      content
      createdAt: created_at
      metadata
      source
      updatedAt: updated_at
      user
      status
      notes {
        id
        data: noteByNote {
          id
          content
          createdAt: created_at
          updatedAt: updated_at
          user
        }
      }
      contacts(order_by: { created_at: desc }) {
        id
        message
        subject
        type
        source
        call_id
        createdAt: created_at
        updatedAt: updated_at
        user {
          id
          name: given_name
          surname: family_name
        }
        call {
          id
          type
          voicemail
          callType: call_type
          payload
          createdAt: created_at
          employee {
            id
            name: given_name
            surname: family_name
          }
          notes {
            id
            data: noteByNote {
              id
              content
              createdAt: created_at
              updatedAt: updated_at
              user
            }
          }
        }
      }
      contacts_aggregate {
        aggregate {
          count
        }
      }
      notes_aggregate {
        aggregate {
          count
        }
      }
      conversions {
        id
        value
        createdAt: created_at
        user: user {
          id
          name: given_name
          surname: family_name
        }
        eventByEvent {
          detail {
            title
          }
        }
      }
    }
  }
`;

export const addLeadNote = gql`
  mutation LeadNote($data: lead_note_insert_input!) {
    insert_lead_note_one(object: $data) {
      id
      note: noteByNote {
        id
        content
        createdAt: created_at
        updatedAt: updated_at
        user
      }
    }
  }
`;

export const addLeadContact = gql`
  mutation LeadContact($data: lead_contact_insert_input!) {
    insert_lead_contact_one(object: $data) {
      id
      message
      subject
      lead
      type
      source
    }
  }
`;

export const addLeadConversion = gql`
  mutation LeadConversion($data: lead_conversion_insert_input!) {
    insert_lead_conversion_one(object: $data) {
      value
      event
      lead
    }
  }
`;

export const insertLead = gql`
  mutation insertLead($data: lead_insert_input!) {
    lead: insert_lead_one(object: $data) {
      id
      status
      createdAt: created_at
    }
  }
`;

export const getIncomingStatus = gql`
  query IncomingStatus {
    status: lead_status {
      value
    }
  }
`;

const incomingBoardLeadFields = `
  id
  due
  content
  callback_date
  createdAt: created_at
  claimed_at
  sales_opportunity_at
  metadata
  source
  data
  updatedAt: updated_at
  user
  who
  status
  lost_reason
  lost_reason_notes
  lost_reason_at
  userByWho {
    id
    given_name
    family_name
  }
  cadence_state {
    id
    started_at
    paused
    paused_at
    version
    touchpoint_logs(order_by: { created_at: asc }) {
      id
      day
      channel
      status
      skip_reason
      skip_notes
      call_outcome
      slot
      created_at
    }
  }
  notes_aggregate {
    aggregate {
      count
    }
  }
  contacts_aggregate(where: { type: { _neq: "call" } }) {
    aggregate {
      count
    }
  }
  linkedCourses {
    id
    title
  }
`;

export const getAllLeads = gql`
  query GetLeads($start: timestamptz!, $end: timestamptz!) {
    leads: lead(
      where: {
        _and: [
          { source: { _nin: ["models_consultation", "models_callback"] } }
          {
            _or: [
              {
                _and: [
                  { created_at: { _gte: $start } }
                  { created_at: { _lte: $end } }
                ]
              }
              {
                _and: [
                  { updated_at: { _gte: $start } }
                  { updated_at: { _lte: $end } }
                ]
              }
              { _and: [{ due: { _gte: $start } }, { due: { _lte: $end } }] }
              {
                _and: [
                  { callback_date: { _gte: $start } }
                  { callback_date: { _lte: $end } }
                ]
              }
            ]
          }
        ]
      }
      order_by: { updated_at: desc_nulls_last }
    ) {
      ${incomingBoardLeadFields}
    }
  }
`;

export const getPipelineLeads = gql`
  query GetPipelineLeads {
    leads: lead(
      where: {
        _and: [
          { status: { _nin: ["BOOKED", "CLOSED"] } }
          { source: { _nin: ["models_consultation", "models_callback"] } }
        ]
      }
      order_by: { updated_at: desc_nulls_last }
    ) {
      ${incomingBoardLeadFields}
    }
  }
`;

export const getTerminalLeads = gql`
  query GetTerminalLeads($start: timestamptz!, $end: timestamptz!) {
    leads: lead(
      where: {
        _and: [
          { source: { _nin: ["models_consultation", "models_callback"] } }
          {
            _or: [
              {
                _and: [
                  { status: { _eq: "BOOKED" } }
                  { updated_at: { _gte: $start } }
                  { updated_at: { _lte: $end } }
                ]
              }
              {
                _and: [
                  { status: { _eq: "CLOSED" } }
                  { lost_reason_at: { _gte: $start } }
                  { lost_reason_at: { _lte: $end } }
                ]
              }
            ]
          }
        ]
      }
      order_by: { updated_at: desc_nulls_last }
    ) {
      ${incomingBoardLeadFields}
    }
  }
`;

export const getModelConsultationLeads = gql`
  query GetModelConsultationLeads($start: timestamptz!, $end: timestamptz!) {
    leads: lead(
      where: {
        _and: [
          { source: { _in: ["models_consultation", "models_callback"] } }
          {
            _or: [
              {
                _and: [
                  { created_at: { _gte: $start } }
                  { created_at: { _lte: $end } }
                ]
              }
              {
                _and: [
                  { updated_at: { _gte: $start } }
                  { updated_at: { _lte: $end } }
                ]
              }
              { _and: [{ due: { _gte: $start } }, { due: { _lte: $end } }] }
              {
                _and: [
                  { callback_date: { _gte: $start } }
                  { callback_date: { _lte: $end } }
                ]
              }
              { status: { _nin: ["BOOKED", "CLOSED"] } }
            ]
          }
        ]
      }
      order_by: { updated_at: desc_nulls_last }
    ) {
      ${incomingBoardLeadFields}
    }
  }
`;

export const getAllLeadsById = gql`
  query GetLeadsById($id: [uuid!]!) {
    leads: lead(where: { id: { _in: $id } }) {
      id
      createdAt: created_at
      content
      metadata
      source
      updatedAt: updated_at
      user
      status
      client {
        id
        name: given_name
        surname: family_name
        email
        phone: contact_number
      }
    }
  }
`;

export const sendAssets = gql`
  mutation SendAssets($data: SendAssetInput!) {
    sendAssets(assets: $data) {
      success
    }
  }
`;

export const addDefinedMessage = gql`
  mutation addDefinedMessage($data: defined_messages_insert_input!) {
    insert_defined_messages_one(object: $data) {
      id
      title
      content
      type
      category
      author_id
    }
  }
`;

export const getDefinedMessages = gql`
  query getDefinedMessages(
    $where: defined_messages_bool_exp
    $orderBy: [defined_messages_order_by!]
    $limit: Int
    $offset: Int
  ) {
    defined_messages(
      where: $where
      order_by: $orderBy
      limit: $limit
      offset: $offset
    ) {
      id
      subject
      created_at
      assets
      updated_at
      title
      content
      type
      category
      author_id
      author {
        id
        full_name
      }
    }
  }
`;

export const updateMessage = gql`
  mutation updateMessage($id: uuid!, $data: defined_messages_set_input!) {
    update_defined_messages_by_pk(pk_columns: { id: $id }, _set: $data) {
      id
      category
      author_id
    }
  }
`;

export const deleteMessage = gql`
  mutation deleteMessage($id: uuid!) {
    delete_defined_messages(where: { id: { _eq: $id } }) {
      affected_rows
    }
  }
`;
